import { useSearchParams } from "react-router-dom";
import { Row, Col } from "react-bootstrap"

export default function NovaSolicitacaoEnviada() {
    const [searchParams, setSearchParams] = useSearchParams();
    const sucesso = searchParams.get("sucesso") ? true : false;
    const hashValue = searchParams.get("hash") ? searchParams.get("hash") : null;
    
    return <Row>
        <Col xs="12">
            <p><small>Você está em <a href="/ouvidoria">SISTEMA DE INFORMAÇÃO AO CIDADÃO E OUVIDORIA</a> / Nova Solicitação</small></p>
        </Col>
        <Col sm="12" className="text-center">
            {sucesso ? <div><p><strong>✔ Formulário enviado.</strong> Anote o número do protocolo: {hashValue}</p></div> : <div><p>Houve um problema ao enviar o formulário. Tente novamente mais tarde.</p></div>}
        </Col>
    </Row>
}